import { forwardRef } from 'react';
import Button from '@hiredigital/ui/Button/NextButtonLink';
import CurveLineMaker from '@components/CurveLineMaker';
import Styles from './SmallCard.module.scss';

const SmallCard = forwardRef((props, ref) => {
  return (
    <div ref={ref} className={Styles.card}>
      <div className={Styles.angle} />
      <h3 className={Styles.title}>
        <CurveLineMaker
          sentence={`Join the highest performing talent today`}
          underlineText={`talent`}
        />
      </h3>
      <Button
        type={Button.Type.BLUE}
        size={Button.Size.HALFWIDTH}
        href={`/talent/register`}
        name='signup'
        style={{ marginTop: '30px' }}>
        {`Apply Now`}
      </Button>
    </div>
  );
});

SmallCard.propTypes = {};

export default SmallCard;
